import axios from "axios";

export const FileService = async (presignedUrl, file) => {
    try {
        const response = await axios.put(presignedUrl, file, {
            headers: {
                "Content-Type": file.type
            },
            timeout: 60 * 1000 // 1 minute
        });

        return {
            status: "ok",
            statusCode: response.status
        };

    } catch (error) {
        console.error(error);

        if (error.code === "ECONNABORTED") {
            // Timeout case
            return {
                status: "error",
                statusCode: 408,
                message: "Upload timed out after 1 minute"
            };
        }

        return {
            status: "error",
            statusCode: error.response ? error.response.status : 500,
            message: error.message
        };
    }
};

export default FileService;
